"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOS_QUERY = exports.ToS = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@apollo/client");
const react_ui_1 = require("@yanzi/react-ui");
const date_fns_1 = require("date-fns");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_1 = require("react");
const LATEST_TOS_DATE = '2018-11-28';
const latestToSTime = date_fns_1.parse(LATEST_TOS_DATE, 'yyyy-MM-dd', new Date());
function ToS({ children }) {
    var _a, _b;
    const checkboxRef = react_1.useRef(null);
    const { data, loading, error } = client_1.useQuery(exports.TOS_QUERY, {
        context: { linkServer: true, suppressErrors: true },
    });
    const [acceptTos, mutationResult] = client_1.useMutation(ACCEPT_TOS_MUTATION, {
        context: { linkServer: true },
    });
    const [alert, setError] = react_ui_1.useErrorAlert();
    const onSubmit = react_1.useCallback(e => {
        if (e.preventDefault) {
            e.preventDefault();
        }
        if (!checkboxRef.current || !checkboxRef.current.checked) {
            setError('Please tick the checkbox to verify that you accept the Terms of Service.');
            return;
        }
        acceptTos({ refetchQueries: [{ query: exports.TOS_QUERY, context: { linkServer: true } }] });
    }, [acceptTos, setError]);
    if ((!data || !Object.keys(data).length) && loading) {
        return null;
    }
    if (((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.timeAcceptedTerms) > latestToSTime ||
        error || (mutationResult === null || mutationResult === void 0 ? void 0 : mutationResult.error) ||
        !data ||
        data.me === undefined) {
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
    }
    return (jsx_runtime_1.jsxs(react_ui_1.AbsoluteBox, Object.assign({ backgroundColor: "pageBackground", display: "flex" }, { children: [jsx_runtime_1.jsx(react_ui_1.Box, Object.assign({ maxWidth: 500, mx: "auto", p: 3, mt: "10%" }, { children: jsx_runtime_1.jsxs(react_ui_1.Card, Object.assign({ backgroundColor: "#fff", color: "#000" }, { children: [jsx_runtime_1.jsx(react_ui_1.CardHeader, { children: jsx_runtime_1.jsx("h2", { children: !((_b = data === null || data === void 0 ? void 0 : data.me) === null || _b === void 0 ? void 0 : _b.timeAcceptedTerms)
                                    ? 'Please accept the Terms of Service'
                                    : 'The Terms of Service has been updated' }, void 0) }, void 0),
                        jsx_runtime_1.jsxs(react_ui_1.CardContent, { children: [jsx_runtime_1.jsx("p", { children: "Please accept the Terms of Service in order to continue using Yanzi's services. If you do not accept the terms, please close this tab/window." }, void 0),
                                jsx_runtime_1.jsxs(react_ui_1.Form, Object.assign({ onSubmit: onSubmit }, { children: [jsx_runtime_1.jsxs(react_ui_1.FormGroup, Object.assign({ checkbox: true }, { children: [jsx_runtime_1.jsx(react_ui_1.Input, { type: "checkbox", name: "checkBoxAccept", id: "checkBoxAccept", defaultChecked: true, ref: checkboxRef, required: true }, void 0),
                                                jsx_runtime_1.jsxs(react_ui_1.Label, Object.assign({ htmlFor: "checkBoxAccept" }, { children: ["I accept the", ' ', jsx_runtime_1.jsx("a", Object.assign({ href: "https://www.yanzi.se/legal/yanzi-terms-of-service.pdf", target: "_blank", rel: "noopener noreferrer" }, { children: "Terms of Service" }), void 0)] }), void 0)] }), void 0),
                                        jsx_runtime_1.jsx(react_ui_1.FormGroup, Object.assign({ mb: 0 }, { children: jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ type: "submit", backgroundColor: "accent", ml: "auto" }, { children: "Accept" }), void 0) }), void 0)] }), void 0)] }, void 0)] }), void 0) }), void 0), alert] }), void 0));
}
exports.ToS = ToS;
exports.TOS_QUERY = graphql_tag_1.default `
  query TosQuery {
    me {
      key
      timeAcceptedTerms
    }
  }
`;
const ACCEPT_TOS_MUTATION = graphql_tag_1.default `
  mutation AcceptToSMutation {
    acceptToS {
      key
    }
  }
`;
//# sourceMappingURL=index.js.map